import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Position } from "../../../../domain/models/position-model";
import { AuditContext } from "./store";
import { StoreItem } from "../../../../domain/models/storage-item";
import { AuditPositionResult } from "../../../../domain/usecases/audit-position";
export const MobileAudit: React.FC = () => {
  const [position, setPosition] = useState<Position | null>(null);
  const [list, setList] = useState<StoreItem[] | null>(null);
  const [result, setResult] = useState<AuditPositionResult | null>(null);
  return (
    <AuditContext.Provider
      value={{ position, setPosition, list, setList, result, setResult }}
    >
      <Outlet />
    </AuditContext.Provider>
  );
};
